var ECheckoutStatus = /*#__PURE__*/ function(ECheckoutStatus) {
    ECheckoutStatus["Incomplete"] = "incomplete";
    ECheckoutStatus["Complete"] = "complete";
    ECheckoutStatus["Cancelled"] = "cancelled";
    ECheckoutStatus["Blacklisted"] = "blacklisted";
    return ECheckoutStatus;
}(ECheckoutStatus || {});
var ECheckoutUserLanguage = /*#__PURE__*/ function(ECheckoutUserLanguage) {
    ECheckoutUserLanguage["English"] = "en";
    ECheckoutUserLanguage["German"] = "de";
    return ECheckoutUserLanguage;
}(ECheckoutUserLanguage || {});
var ECheckoutCustomerType = /*#__PURE__*/ function(ECheckoutCustomerType) {
    ECheckoutCustomerType["Individual"] = "individual";
    ECheckoutCustomerType["Company"] = "company";
    return ECheckoutCustomerType;
}(ECheckoutCustomerType || {});
export { ECheckoutStatus, ECheckoutUserLanguage, ECheckoutCustomerType };
